import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    haul: 0,
    requestCompleted: null
  },
  getters: {
    showRequestCompleted(state) {
      return state.requestCompleted;
    }
  },
  mutations: {
    addHaul(state) {
      state.haul += 1;
    },
    setRequestCompleted(state, newRequestCompleted) {
      state.requestCompleted = newRequestCompleted;
    }
  },
  actions: {
    async addHaul({ commit }, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/haul/`,
          info,
          api.getToken()
        );
        if (response.status === 201) {
          commit("addHaul");
          return response;
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 201) {
          errorMessage();
        }
        return err.response;
      }
    },

    async updateHaul({ commit }, info) {
      let validateRequestItemsTable = false;
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE + `/api/haul/${info.haulId}/`,
          info.payload,
          api.getToken()
        );
        commit("setRequestCompleted", validateRequestItemsTable);
        if (response.status === 200) {
          validateRequestItemsTable = true;
          commit("addHaul");
          commit("setRequestCompleted", validateRequestItemsTable);
          return response;
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async deleteHaul({ commit }, haulId) {
      try {
        let response = await axios.delete(
          process.env.VUE_APP_BACK_ROUTE + `/api/haul/${haulId}/`,
          api.getToken()
        );
        if (response.status === 204) {
          commit("addHaul");
          return response;
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 204) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
